import { abstractApiCaller } from "./apiCaller";
import {
    requestCodeValidityResponse,
    requestEmailHashResponse,
    requestSessionValidationResponse
} from "../types/api/login";

class UserSessionApi extends abstractApiCaller {

    public async requestEmailToken(email:string)
    {
        const endpoint = 'login/requestCodeHash';

        const param = {
            'userEmail': email,
        };

        this.abortRequest();
        return await this.query<requestEmailHashResponse | undefined>(endpoint, param);
    }

    public async requestCodeValidation(email:string, code:string)
    {
        const endpoint = 'login/requestCodeValidation';

        const param = {
            'userEmail': email,
            'code': code,
        };

        this.abortRequest();
        return await this.query<requestCodeValidityResponse | undefined>(endpoint, param);
    }

    public async requestSessionValidation(token: string, email: string)
    {
        const endpoint = 'login/requestSessionValidity';

        const param = {
        };

        this.abortRequest();
        return await this.query<requestSessionValidationResponse | undefined>(endpoint, param, token, email);
    }
}

export { UserSessionApi };
